export default "__VITE_ASSET__CmW6fOdq__"